export abstract class AuthService {
    /**
     * Log-in into the app using user and password
     * @param username a valid user id
     * @param password a valid password
     */
    abstract login(username: string, password: string) : any;

    /**
     * Logout from the app
     */
    abstract logout() : any;
}
